import { createAsyncThunk } from '@/redux/createAsyncThunk';
import { fetchItemCarousels } from './itemCarousel.api';
import { FetchItemCarouselsPayload } from './itemCarousel.types';
import { getAuthToken } from '@/redux/modules/account/user/user.selectors';
import { getClientIpAddress } from '../browser';
import { getDeployment } from '../config';
import { getIsBot } from '../analytics';
import { shouldFetchCarousel } from './itemCarousel.selectors';

type FetchItemCarouselsParams = {
    itemId: number;
    shouldUseSignalsBoost?: boolean;
    useNewSimilarItems?: boolean;
    useScoutCategories?: boolean;
};

export const loadItemCarousels = createAsyncThunk<FetchItemCarouselsPayload, FetchItemCarouselsParams>(
    'la/domain/items/fetchItemCarousels',
    async ({ itemId, shouldUseSignalsBoost, useNewSimilarItems, useScoutCategories }, { getState }) => {
        const state = getState();
        const authToken = getAuthToken(state);
        const deployment = getDeployment(state);
        const ipAddress = getClientIpAddress(state);
        const isBot = getIsBot(state);
        const { payload: carousels } = await fetchItemCarousels({
            authToken,
            deployment,
            ipAddress,
            isBot,
            itemId,
            useNewSimilarItems,
            useScoutCategories,
            useSignalsBoost: shouldUseSignalsBoost,
        });
        return { carousels, itemId };
    }
);

type FetchItemCarouselsIfNeededParams = {
    itemId: number;
    shouldUseSignalsBoost?: boolean;
    useNewSimilarItems?: boolean;
    useScoutCategories?: boolean;
};

export const fetchItemCarouselsIfNeeded = createAsyncThunk<void, FetchItemCarouselsIfNeededParams>(
    'la/domain/items/fetchItemCarouselsIfNeeded',
    async ({ itemId, shouldUseSignalsBoost, useNewSimilarItems, useScoutCategories }, { dispatch, getState }) => {
        const state = getState();
        if (shouldFetchCarousel(state, itemId)) {
            await dispatch(
                loadItemCarousels({
                    itemId,
                    shouldUseSignalsBoost,
                    useNewSimilarItems,
                    useScoutCategories,
                })
            );
        }
    }
);
